export default "__VITE_ASSET__BLf03aey__"